"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.free = void 0;
var verifications_1 = require("../verifications");
/**
 *  Удаляет null и null свойства из переданного объекта (рекурсивно, deep).
 *  @example
 *  const withNull = {
 *    a: 'some',
 *    b: { d: 123, e: {f: null, t: 8} }
 *    c: null
 *  }
 *  free(withNull) // -> { a: 'some', b: { d: 123, e: { t: 8 } } }
 */
function free(obj) {
    if (!(0, verifications_1.isObject)(obj)) {
        // короткая запись
        // tslint:disable-next-line:no-object-literal-type-assertion
        return obj;
    }
    return Object.keys(obj).reduce(function (acc, val) {
        var _a;
        if (obj[val] !== null) {
            var newVal = (0, verifications_1.isObject)(obj[val]) ? free(obj[val]) : obj[val];
            return Object.assign(acc, (_a = {},
                _a[val] = Array.isArray(newVal) ? newVal.map(function (item) { return (0, verifications_1.isObject)(item) ? free(item) : item; }) : newVal,
                _a));
        }
        return acc;
        // тк иначе не напишешь коротко
        //tslint:disable-next-line:no-object-literal-type-assertion
    }, {});
}
exports.free = free;
//# sourceMappingURL=free.js.map